import { ChillPortionsConfigType } from './types';
import { getDaysInMonth } from '../../utils/DayMonthBaseForm';

export interface ValidationErrors {
  [key: string]: string;
}

const validateMonthDay = (
  month: number,
  day: number,
  monthField: string,
  dayField: string,
  errors: ValidationErrors,
) => {
  if (!month || month < 1 || month > 12) {
    errors[monthField] = 'El mes debe estar entre 1 y 12';
  }
  if (!day || day < 1 || day > 31) {
    errors[dayField] = 'El día debe estar entre 1 y 31';
  }
  if (month && day) {
    const maxDays = getDaysInMonth(month);
    if (day > maxDays) {
      errors[dayField] = `El día no puede ser mayor a ${maxDays} para el mes seleccionado`;
    }
  }
};

export const validateConfig = (config: ChillPortionsConfigType): ValidationErrors => {
  const errors: ValidationErrors = {};

  validateMonthDay(
    config.chillPortionsStartMonth,
    config.chillPortionsStartDay,
    'chillPortionsStartMonth',
    'chillPortionsStartDay',
    errors,
  );

  validateMonthDay(
    config.chillPortionsEndMonth,
    config.chillPortionsEndDay,
    'chillPortionsEndMonth',
    'chillPortionsEndDay',
    errors,
  );

  return errors;
};
